// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.page-numbers[data-v-fd90bcd6]{color:#337ab7}a.page-numbers.next[data-v-fd90bcd6],a.page-numbers.prev[data-v-fd90bcd6]{color:#333}", ""]);
// Exports
module.exports = exports;
